import styled from "styled-components";

export const ButtonCommon = styled.button<{
  background?: string;
  textColor?: string;
  disabled?: boolean;
  width?: string;
}>`
  background-color: ${({ disabled, background }) =>
    disabled ? "#43424a" : background || "#E84142"};
  opacity: ${({ disabled }) => disabled && "50%"};
  color: #fff;
  width: ${({ width }) => (width ? width : "100%")};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 18px;
  cursor: ${({ disabled }) => (disabled ? "no-drop" : "pointer")};
  transition: all 0.15s linear;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25),
    0px 3px 0px 0px rgba(186, 186, 186, 0.33) inset;
  &:active {
    transform: translateY(4%);
  }
  p {
    color: ${({ color }) => color};
    font-size: 14px;
  }
  a {
    color: #fff;
  }
  &.light {
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25),
      0px 3px 0px 0px rgba(186, 186, 186, 0.33) inset;
    background-color: ${({ disabled, background }) =>
      disabled ? "#B32222" : background || "#B32222"};
  }
`;